import colors from "utils/styles";

export const checkBoxStyles = {
    label: {
        color: 'white',
        fontSize: '0.9rem',
    },
    input: {
        cursor: 'pointer',
    },
}

export const textStyles = { fontSize: '1.25rem', color: 'white', fontWeight: 'bold' };

export const numberInputStyles = {
    input: {
        backgroundColor: colors.appYellow,
        color: colors.appPink,
        fontSize: '1.2rem',
        textAlign: 'center',
    },
    control: {
        backgroundColor: colors.appPink,
        color: 'white',
        border: 'none',
        '&:hover': {
            backgroundColor: colors.appDarkPink,
        },
    },
    label: {
        color: 'white',
    },
    description: {
        color: 'white',
        fontSize: '0.75rem',
    }
}

export const numberAdultInputStyles = {
    input: {
        backgroundColor: colors.appYellow,
        color: colors.appPink,
        fontSize: '1.2rem',
        textAlign: 'center',
    },
    control: {
        backgroundColor: colors.appPink,
        color: 'white',
        border: 'none',
        '&:hover': {
            backgroundColor: colors.appDarkPink,
        },
    },
    label: {
        color: 'white',
    },
    description: {
        color: 'white',
        fontSize: '0.75rem',
    }
}
export const datePickerStyles = () => ({
    monthCell: {
        backgroundColor: 'transparent',
    },
    calendarHeader: {
        backgroundColor: 'transparent',
        color: colors.appYellow,
        fontSize: '1.5rem',
        fontWeight: 'bold',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    weekday: {
        color: colors.appYellow,
        padding: '4px',
        fontSize: '1rem',
        fontWeight: 'bold',
    },
})

export const getInputStyles = (errors: any) => {
    return {
        input: {
            color: 'white',
            borderBottom: '1px solid white',
            borderTop: '1px solid transparent',
            borderLeft: '1px solid transparent',
            borderRight: '1px solid transparent',
            '&::placeholder': {
                color: 'white'
            }
        },
        label: {
            color: 'white',
            float: 'left',
            marginBottom: '-10px',
        },
        error: {
            color: colors.appOrange,
            float: 'left',
        },
        root: {
            paddingBottom: `${!errors ? '20px' : '0px'}`,
        }
    };
}

export const getTextareaStyles = (errors: any) => {
    return {
        input: {
            color: 'white',
            borderBottom: '1px solid white',
            borderTop: '1px solid transparent',
            borderLeft: '1px solid transparent',
            borderRight: '1px solid transparent',
            backgroundColor: 'transparent',
            minHeight: 'unset',
            height: '42px',
            padding: '8px 0',
            '&::placeholder': {
                color: 'white'
            },
            '&:focus': {
                borderBottom: `1px solid ${colors.appYellow}`
            }
        },
        label: {
            color: 'white',
            float: 'left',
            marginBottom: '-10px',
        },
        error: {
            color: colors.appOrange,
            float: 'left',
        },
        root: {
            paddingBottom: `${!errors ? '20px' : '0px'}`,
        },
        wrapper: {
            width: '100%'
        }
    };
}